import { render, staticRenderFns } from "./AppointmentConfigModal.vue?vue&type=template&id=b1ff8474&"
import script from "./AppointmentConfigModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports